import { reactive } from 'vue'
import { getConfigMap } from '../api'

// 系统基础配置全局响应式对象（key 与后端 sys_config 表 config_key 对应）
export const sysConfig = reactive({
  system_name: '',      // 系统名称
  system_version: '',   // 系统版本号
  copyright: '',        // 版权信息
  home_title: '',       // 首页标题
  dashboard_name: '',   // 可视化名称（大屏标题）
  system_logo: ''       // 系统 LOGO 图片地址
})

// 从后端拉取配置并合并到 store（仅更新已存在的 key）
export async function loadSysConfig() {
  try {
    const res = await getConfigMap()
    const map = (res && res.data) || {}
    Object.keys(sysConfig).forEach(k => {
      if (map[k] != null && map[k] !== '') sysConfig[k] = map[k]
    })
    return map
  } catch (e) {
    return {}
  }
}
